import { common as ruCommon } from './ru/common';
import { common as enCommon } from './en/common';
import { common as esCommon } from './ro/common';


export const resources = {
  ru: {
    translation: {
      ...ruCommon,
    },
  },
  en: {
    translation: {
      ...enCommon,
    },
  },
  ro: {
    translation: {
      ...esCommon,
    },
  },
};
